import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import ListWidget from "app/static/frontend/widgets/components/ListWidget"

// action creators
import { segueToProfile } from "app/static/frontend/global-action-creators"
import { segueToSearch } from "app/static/frontend/search-new/action-creators"
import { showInSearch } from "app/static/frontend/projects-new/list/action-creators"

// selectors
import {
    selectWidgetDataSources,
    selectWidgetDescription,
    selectWidgetFilters,
    selectWidgetKey,
    selectWidgetQuorumDataType,
    selectCanWidgetLoad
} from "app/static/frontend/widgets/selectors/selectors"

const mapStateToProps = createStructuredSelector({
    canLoad: selectCanWidgetLoad,
    dataSources: selectWidgetDataSources,
    description: selectWidgetDescription,
    filters: selectWidgetFilters,
    qdt: selectWidgetQuorumDataType,
    widgetKey: selectWidgetKey,
})

const mapDispatchToProps = {
    segueToProfile,
    segueToSearch,
    showInSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(ListWidget)
